// LIST OF SEARCH RESULT
import {Model} from "@/store/models/model"

export class PageControl extends Model {
  static entity = 'pagecontrol'
  static primaryKey = 'path'
  static fields() {
    return {
      user:this.attr(null),
      id:this.attr(null),
      name:this.string('Name'),
      role:this.attr(null),
      permissions:this.attr(null),
      path:this.string('Path'),
      path_from:this.attr(null),
      path_to:this.attr(null),
      information:this.attr(null),
      advertisement:this.attr(null),
      errors:this.attr(false),
      selected: this.attr(null),
      error:this.attr(null),
      osoption:this.attr(null),
      response:this.attr(null),

      //BOOL
      edit: this.attr(false),
      activate:this.attr(false),
      available: this.attr(false),
      spinner:this.attr(false),
      pending:this.attr(false),
      changes:this.attr(false),
      save:this.attr(false),
      create:this.attr(false),
      show:this.attr(false),

    }
  }

  static activate(path){
    return PageControl.update({where:path,data:{activate:true}})
  }

}

export default PageControl



// WEBPACK FOOTER //
// ./src/store/models/layout/page_control.js